import { createSlice } from '@reduxjs/toolkit';
import { initial } from 'lodash';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const initialState = {
  displayingStatus: false,
  initialIndex: 0,
};

export const paywallSlice = createSlice({
  name: 'paywall',
  initialState,
  reducers: {
    setDisplayingStatus(state) {
      state.displayingStatus = !state.displayingStatus;
    },
    setInitialIndex(state, action) {
      state.initialIndex = action.payload;
    },
  },
});

export const { setDisplayingStatus, setInitialIndex } = paywallSlice.actions;

export const selectPaywallStatus = state => state.paywall.displayingStatus;
export const selectInitialIndex = state => state.paywall.initialIndex;

export default persistReducer(
  {
    key: 'rtk:paywall',
    storage,
    whitelist: ['displayingStatus, initialIndex'],
  },
  paywallSlice.reducer,
);
